import React, { useEffect, useMemo, useState } from 'react';
import style from "./index.module.scss"
import { Order } from '../../../services';
import { toast } from 'react-toastify';

import CloseIcon from "../../shared/icons/CloseIcon";
import OrdersSectionItemInfoColumn from "../section-item/components/OrdersSectionItemInfoColumn";
import SelectCustom from "../../shared/forms/select-custom";
import InputCustom from "../../shared/forms/input-custom";
import { useSelector } from 'react-redux';
import { useLanguage } from '../../../context/LanguageContext';
import { Trans, useTranslation } from "react-i18next";

const normalizeCityName = (value) => typeof value === "string" ? value.trim() : "";

const AddYourCity = ({
  setCountry,
  setCity,
  countries,
  country,
  setIsСallСities,
  setAddedCityId,
  isOpenAdd,
  setIsOpenAdd,
  initialCityName = "",
}) => {
  const { t } = useTranslation();
  const { user } = useSelector(state => state);
  const { currentLanguage } = useLanguage();
  const normalizedInitialCityName = normalizeCityName(initialCityName);
  const [cityName, setCityName] = useState(normalizedInitialCityName);
  const [cities, setCities] = useState([]);

  const handleClose = () => {
    setCityName("");
    setIsOpenAdd(false);
  }

  const fetchCities = async (countryId) => {
    try {
      const response = await Order.getCities(currentLanguage, countryId);
      setCities(response.data);
    } catch (error) {
      console.error('Ошибка при получении городов:', error);
    }
  };

  useEffect(() => {
    if (isOpenAdd) {
      setCityName(normalizedInitialCityName);
    }
  }, [isOpenAdd, normalizedInitialCityName]);

  useEffect(() => {
    if (cityName) {
      fetchCities(country.id);
      // console.log("получении городов:", cities)
    }
  }, [cityName]);

  const addCityToServer = async () => {

    const existingCity = cities.find(city => city.name.toLowerCase() === cityName.toLowerCase());
    if (existingCity) {
      toast.error(t("addYourCity.alreadyExists"));
      return;
    }

    try {
      const response = await Order.getAddYourCity({
        countryId: country.id,
        name: cityName,
      });

      setIsСallСities(country.id)
      handleClose();
      setAddedCityId(response.data)
      toast.info(t("addYourCity.success"));
    } catch (error) {
      console.error('Ошибка при добавлении города:', error);
    }
  };

  return (
    <>
      {isOpenAdd &&
        <div className="modal-overlay" onMouseDown={(e) => e.stopPropagation()}>
          <div className={style.modal} onMouseDown={(e) => e.stopPropagation()}>
            <div style={{
              position: "relative",
              width: "100%",
              display: "flex",
              flexDirection: "column",
            }}>
              <CloseIcon width={20} height={20} onClick={() => { handleClose() }} fill={'#909195'}
                style={{
                  position: 'absolute',
                  top: "-15px",
                  right: "-15px",
                }} />
              <div className={style.title}>
                {t("addYourCity.title")}
              </div>
              <span className={style.titleSub}>
                <Trans t={t} i18nKey="addYourCity.description" components={{ lineBreak: <br /> }} />
              </span>
              <div style={{ marginTop: "20px", }}>
                <OrdersSectionItemInfoColumn title={t("addYourCity.countryLabel")}>
                  <SelectCustom
                    key={'countries-from'}
                    placeholder={t("addYourCity.countryPlaceholder")}
                    options={countries}
                    defaultValue={country}
                    returnObject
                    onSubmit={(item) => {
                      setCountry(item);
                      setCity(null);
                    }}
                  />
                </OrdersSectionItemInfoColumn>
              </div>
              <div style={{ marginTop: "14px", }}>
                <OrdersSectionItemInfoColumn title={t("addYourCity.cityLabel")}>
                  <InputCustom
                    key={`${country?.id || "no-country"}-${normalizedInitialCityName}`}
                    placeholder={t("addYourCity.cityPlaceholder")}
                    inputType="text"
                    defaultValue={normalizedInitialCityName}
                    onChangeValue={(item) => {
                      setCityName(item);
                    }}
                  />
                </OrdersSectionItemInfoColumn>
              </div>
            </div>
            <button className={style.btn} style={{ width: '200px', marginTop: '20px' }} onClick={addCityToServer}>{t("addYourCity.addButton")}</button>
          </div>
        </div >
      }
    </>

  );
};

export default AddYourCity;
